module.exports = "/static/assets/9ce846b427193dfc81e99f6495b535ce.png";